<template lang="pug">
  .apply-log
    el-tabs(v-model="activeTab" @tab-click="handleTabChange")
      el-tab-pane(label="申请记录" name="records")
        header.flex-_-center
          el-form
            el-form-item.fl(label="")
              el-input.search-input(placeholder="(姓名，邮箱)模糊查询，回车搜索" v-model="searchData.keywords" style="width: 350px" @keyup.enter="getList" clearable)
                el-button(slot="append" icon="el-icon-search" @click="getList()")
            el-form-item.fl
              .time.flex-_-center
                span.apply-time 申请时间筛选：
                el-date-picker(
                  v-model='sDate',
                  @change='getList',
                  format="yyyy 年 MM 月 dd 日",
                  value-format="yyyy-MM-dd"
                  type='daterange',
                  range-separator='至',
                  start-placeholder='开始日期',
                  end-placeholder='结束日期',
                  placeholder='选择日期查询',
                  style="width: 380px",
                  :clearable="false"
                )
            el-form-item.fl
              el-button.export-btn(type="primary" @click="exportExcel" :loading="exportLoading") 导出Excel
        el-table(:data="tableData" v-loading="loading")
          el-table-column(label="申请人" prop="originator_name" align="center" width="200")
          el-table-column(label="申请人部门" prop="created_by_dept" align="center" width="200")
            template(#default='scope')
              span {{ scope.row.created_by_dept || '-' }}
          el-table-column(label="发送邮箱" prop="originator_email")
          el-table-column(label="发送报告" prop="report")
            template(#default='scope')
              span {{ spellTitle(scope.row.report) }}
          el-table-column(label="申请时间" prop="created_at" )
            template(#default='scope')
              span {{ changeData(scope.row.createdAt) }}
        el-pagination(
          background
          @current-change='handleCurrentChange'
          layout='slot, prev, pager, next'
          :currentPage='currentPage'
          :page-size='GLOBAL.pageSize'
          :total='totalNum'
        )
          span(style='margin-right: 8px') 共{{ totalNum }}条

      el-tab-pane(label="用户统计" name="statistics")
        header.flex-_-center
          el-form
            el-form-item.fl(label="")
              el-input.search-input(placeholder="(姓名，邮箱)模糊查询，回车搜索" v-model="searchData.keywords" style="width: 350px" @keyup.enter="getStatistics" clearable)
                el-button(slot="append" icon="el-icon-search" @click="getStatistics()")
            el-form-item.fl
              .time.flex-_-center
                span.apply-time 申请时间筛选：
                el-date-picker(
                  v-model='sDate',
                  @change='getStatistics',
                  format="yyyy 年 MM 月 dd 日",
                  value-format="yyyy-MM-dd"
                  type='daterange',
                  range-separator='至',
                  start-placeholder='开始日期',
                  end-placeholder='结束日期',
                  placeholder='选择日期查询',
                  style="width: 380px",
                  :clearable="false"
                )
            el-form-item.fl
              el-button.export-btn(type="primary" @click="exportStatisticsExcel" :loading="exportLoading") 导出Excel
        el-table(:data="statisticsData" v-loading="loadingStatistics")
          el-table-column(label="申请人" prop="originator_name" align="center" width="200")
          el-table-column(label="申请人部门" prop="created_by_dept" align="center" width="200")
            template(#default='scope')
              span {{ scope.row.created_by_dept || '-' }}
          el-table-column(label="邮箱" prop="originator_email" align="center")
          el-table-column(label="申请次数" prop="count" align="center" width="150")
        el-pagination(
          background
          @current-change='handleStatisticsCurrentChange'
          layout='slot, prev, pager, next'
          :currentPage='statisticsCurrentPage'
          :page-size='GLOBAL.pageSize'
          :total='statisticsTotalNum'
        )
          span(style='margin-right: 8px') 共{{ statisticsTotalNum }}条
</template>
<script>
// import { formatDate } from 'utils/index'

import api from '@/apis/apply'
import { parseTime } from '@/javascripts/time'
import { exportToExcel } from '@/javascripts/excel'
export default {
  data () {
    return {
      activeTab: 'records',
      tableData: [],
      loading: false,
      searchData: {
        keywords: ''
      },
      currentPage: 1,
      totalNum: 0,
      sDate: [],
      statisticsData: [],
      loadingStatistics: false,
      statisticsCurrentPage: 1,
      statisticsTotalNum: 0,
      exportLoading: false
    }
  },
  created () {
    this.getList()
  },
  methods: {
    // Tab切换
    handleTabChange (tab) {
      this.searchData.keywords = ''
      this.sDate = []
      if (tab.name === 'records') {
        this.currentPage = 1
        this.getList()
      } else {
        this.statisticsCurrentPage = 1
        this.getStatistics()
      }
    },
    // 分页切换
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    },
    // 统计分页切换
    handleStatisticsCurrentChange (val) {
      this.statisticsCurrentPage = val
      this.getStatistics()
    },
    getList () {
      this.loading = true
      if (this.sDate.length) {
        Object.assign(this.searchData, {
          start_date: this.sDate[0],
          end_date: this.sDate[1]
        })
      }
      api.reqGetApplyPage({ pageNo: this.currentPage, where: this.searchData })
        .then((res) => {
          if (res.errCode !== 0) this.$message({ type: 'error', message: res.message })
          this.tableData = res.data.data
          this.totalNum = res.data.count
        })
        .finally(() => (this.loading = false))
    },
    // 获取用户统计数据
    getStatistics () {
      this.loadingStatistics = true
      if (this.sDate.length) {
        Object.assign(this.searchData, {
          start_date: this.sDate[0],
          end_date: this.sDate[1]
        })
      }
      api.reqGetApplyStatistics({ pageNo: this.statisticsCurrentPage, where: this.searchData })
        .then((res) => {
          if (res.errCode !== 0) this.$message({ type: 'error', message: res.message })
          this.statisticsData = res.data.data
          this.statisticsTotalNum = res.data.count
        })
        .finally(() => (this.loadingStatistics = false))
    },
    // 导出申请记录Excel
    exportExcel () {
      this.exportLoading = true
      const searchData = { ...this.searchData }
      if (this.sDate.length) {
        Object.assign(searchData, {
          start_date: this.sDate[0],
          end_date: this.sDate[1]
        })
      }
      api.exportApplyRecords({ where: searchData })
        .then((res) => {
          if (res.errCode !== 0) {
            this.$message({ type: 'error', message: res.message })
            return
          }
          // 准备Excel数据
          const headers = ['申请人', '申请人部门', '发送邮箱', '发送报告', '申请时间']
          const data = res.data.map(item => {
            const reportTitle = item.report ? this.spellTitle(item.report) : ''
            const createdAt = item.createdAt ? new Date(item.createdAt).toLocaleString('zh-CN') : ''
            return [
              item.originator_name || '',
              item.created_by_dept || '-',
              item.originator_email || '',
              reportTitle,
              createdAt
            ]
          })
          // 导出Excel
          const filename = `申请记录_${new Date().getTime()}.xls`
          exportToExcel(headers, data, filename)
          this.$message({ type: 'success', message: '导出成功' })
        })
        .catch((err) => {
          this.$message({ type: 'error', message: '导出失败' })
          console.error(err)
        })
        .finally(() => (this.exportLoading = false))
    },
    // 导出用户统计Excel
    exportStatisticsExcel () {
      this.exportLoading = true
      const searchData = { ...this.searchData }
      if (this.sDate.length) {
        Object.assign(searchData, {
          start_date: this.sDate[0],
          end_date: this.sDate[1]
        })
      }
      api.exportApplyStatistics({ where: searchData })
        .then((res) => {
          if (res.errCode !== 0) {
            this.$message({ type: 'error', message: res.message })
            return
          }
          // 准备Excel数据
          const headers = ['申请人', '申请人部门', '邮箱', '申请次数']
          const data = res.data.map(item => {
            return [
              item.originator_name || '',
              item.created_by_dept || '-',
              item.originator_email || '',
              item.count || 0
            ]
          })
          // 导出Excel
          const filename = `用户统计_${new Date().getTime()}.xls`
          exportToExcel(headers, data, filename)
          this.$message({ type: 'success', message: '导出成功' })
        })
        .catch((err) => {
          this.$message({ type: 'error', message: '导出失败' })
          console.error(err)
        })
        .finally(() => (this.exportLoading = false))
    },
    spellTitle (row) {
      const info = row.title + this.typeChange(
        Number(row.briefType)
      )
      return info
    },
    typeChange (type) {
      if (typeof type !== 'number') return ''
      const ReportType = [
        { value: 0, label: '短报告' },
        { value: 1, label: '普通报告' },
        { value: 2, label: '深度报告' },
        { value: 3, label: '简报' },
        { value: 4, label: '白皮书' },
        { value: 5, label: '头豹推荐' }
      ]
      return (ReportType.find(item => item.value === type) || {}).label || ''
    },
    changeData: function (val) {
      if (!val) return '暂无日期'
      var date = new Date(val)
      return parseTime(date, '{y}-{m}-{d}')
    }
  }
}
</script>
<style scoped>
.apply-log {
  height: calc(100% - 40px);
  padding: 20px;
  background: #fff;
  box-sizing: border-box;
}

.el-pagination {
  justify-content: flex-end;
  margin-top: 10px;
}
header {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

header .time {
  margin-left: 20px;
}
.apply-time {
  margin-left: 20px;
}
.export-btn {
  margin-left: 20px;
}
</style>
